import React, { ReactNode } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Box, Typography, IconButton } from '@mui/material';

interface SidePanelProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  drawerWidth?: number;
  children: ReactNode;
}

/** */
const SidePanel: React.FC<SidePanelProps> = ({
  open,
  onClose,
  title = 'Panel lateral',
  drawerWidth = 350,
  children,
}) => {
  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: drawerWidth, p: 2 } }}
    >
      <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
        <Typography variant='h6' fontWeight='bold'>
          {title}
        </Typography>
        <IconButton onClick={onClose} size='small' aria-label='Cerrar panel'>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box sx={{ overflowY: 'auto', minHeight: '90vh' }}>{children}</Box>
    </Drawer>
  );
};

export default SidePanel;
